// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1212":"b9d0e1db","1546":"ee4954af","4044":"77a2959f","7325":"b9d0e1db","9984":"5b2f9530"}[chunkId] + ".chunk.css";
};